import React from 'react';
import { ContentItem } from '@/components/M_Molecules/M_ContentCard/M_ContentCard';
import M_ContentCard from '@/components/M_Molecules/M_ContentCard/M_ContentCard';
import { W_MasonryGrid } from '@/components/W_Wrappers/W_MasonryGrid/W_MasonryGrid';
import styles from './CapsuleCreateContentView.module.css';
import { Capsule } from '@/services/capsulesApi';
import W_CapsuleContentEmptyState from '@/components/W_Wrappers/W_CapsuleContentEmptyState/W_CapsuleContentEmptyState';

interface CapsuleCreateContentViewProps {
  content: ContentItem[];
  capsule: Capsule;
  onSaveContent: (contentItem: any) => void;
}

export default function CapsuleCreateContentView({
  content,
  onSaveContent,
}: CapsuleCreateContentViewProps) {
  return (
    <div className={styles.wrapper}>
      {content.length > 0 ? (
        <W_MasonryGrid>
          {content.map(item => (
            <div key={item.id}>
              <M_ContentCard content={item} />
            </div>
          ))}
        </W_MasonryGrid>
      ) : (
        <W_CapsuleContentEmptyState onSaveContent={onSaveContent} />
      )}
    </div>
  );
}
